<div [ngBusy]="{busy: busy, message: ('common.pleaseWait' | translate)}">
  <div *ngIf="deliveryAddresses?.length" class="mb-4">
    <span class="text-pink pointer delivery-address"
          (click)="chooseDeliveryAddress()"
          [innerHTML]="'orderProcess.delivery.deliveryForms.chooseDeliveryAddress' | translate"
    >Choose a saved delivery address</span>
  </div>

  <div class="delivery-to-door-container">
    <div class="form-group form-group-xl">
      <label [translate]="'common.delivery.deliveryAddress'"></label>

      <ui-input-loader-wrap [loading]="busyAddress">
        <ui-typeahead-address
          [countryCode]="countryCode"
          [placeholder]="'orderProcess.delivery.deliveryForms.deliveryAddressPlaceholder' | translate"
          [ngModel]="lookupAddress"
          (ngModelChange)="resetDeliveryState()"
          (selectItem)="onAddressSelected($event)"
          (busySearch)="busyAddress = $event"
        ></ui-typeahead-address>
      </ui-input-loader-wrap>

      <div class="text-muted font-xs mt-2">
        <span [translate]="'orderProcess.delivery.deliveryForms.addressSearchHint'"></span>
        <span [innerHTML]="deliveryNote"></span>
      </div>
    </div>
  </div>

  <div class="text-danger"
       *ngIf="geoLocationStatus === STATUS.MISSING_STREET_NUMBER"
       [translate]="'orderProcess.delivery.deliveryForms.missingStreetNumber'">
  </div>

  <div class="mb-3" *ngIf="geoLocationStatus === STATUS.INVALID">
    <div class="text-danger"
         [translate]="'orderProcess.delivery.deliveryForms.notAvailable'">
    </div>

    <div class="mt-3 font-md text-center text-color-default text-underline"
         *ngIf="isAnotherDeliveryAvailable">
        <span [translate]="'orderProcess.delivery.deliveryForms.chooseAnotherDeliveryInstead'"
              (click)="onChooseAnotherDelivery.emit()">Pick up in store instead?</span>
    </div>
  </div>

  <ng-container *ngIf="geoLocationStatus === STATUS.VALID">
    <div class="delivery-days-wrap mb-4 mt-1"
         *ngIf="deliveryPrices">
      <div class="delivery-days-title">{{ 'orderProcess.cakesOverview.delivery.times' | translate }}</div>

      <delivery-days-info
        [deliveryPrices]="deliveryPrices"
        [currencySymbol]="currency"
        [overwritingDelivery]="overwritingDelivery"
      ></delivery-days-info>
    </div>

    <deliveries-notes
      class="d-block my-3"
      *ngIf="deliveryNoteForCustomer || availableProductTypes?.length"
      [deliveryNoteForCustomer]="deliveryNoteForCustomer"
      [availableProductTypes]="availableProductTypes">
    </deliveries-notes>

    <daily-stock-sold-out-notice
      class="d-block my-3"
      [productTypes]="dailyStockSoldOutProductTypes"
    ></daily-stock-sold-out-notice>

    <sold-out-msg
      class="d-block my-3"
      *ngIf="fullCapacityDays?.length"
      [fullCapacityDays]="fullCapacityDays"
    ></sold-out-msg>

    <ui-message
      *ngIf="deliveryError"
      class="d-block my-3"
      [type]="'error'"
      [title]="deliveryError.title">
      <div>{{ deliveryError.message }}</div>
    </ui-message>

    <form [formGroup]="deliveryForm">
      <div class="row">
        <div class="col-6 col-lg-4">
          <div class="form-group form-group-xl delivery-datepicker-container">
            <label #datePickerLabel
                   [translate]="'common.delivery.deliveryDate'"></label>

            <ui-delivery-datepicker
              [calendar]="calendar"
              [disabled]="isCalendarLoading"
              [formControlName]="'deliveryDate'"
              [maxDate]="maxDate"
              [placement]="'bottom-left'"
              (onMonthNavigate)="onMonthNavigate($event)"
              (onContextInit)="contextInit($event)"
            ></ui-delivery-datepicker>
          </div>
        </div>

        <div class="col-6 col-lg-4">
          <div class="form-group form-group-xl">
            <label [translate]="'orderProcess.delivery.deliveryForms.chooseTime'"></label>

            <div class="dropdown-container dropdown-item-slim delivery-to-door-time">
              <ui-dropdown
                #rangeDropDown
                [items]="deliveryTimeItems"
                [placeholder]="'common.timePlaceholder' | translate"
                [formControlName]="'deliveryTime'"
                (changeItem)="timeChanged($event)"
              ></ui-dropdown>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-4"
             *ngIf="showDeliveryPricesInfo && isPriceSet">
          <div class="form-group form-group-xl clearfix">
            <label class="price-label"
                   [translate]="'orderProcess.delivery.deliveryForms.deliveryPrice'">
            </label>

            <div class="price-nok">
              {{ price | currencyFormat: currency }}
            </div>
          </div>
        </div>
      </div>

      <div class="mb-4" *ngIf="isDateTimeValid()">
        <div class="form-group form-group-xl">
          <label [translate]="'orderProcess.delivery.deliveryForms.recipientName'"></label>

          <input type="text"
                 class="form-control"
                 [maxlength]="'128'"
                 [placeholder]="'common.name' | translate"
                 [formControlName]="'deliveryUserName'">
        </div>

        <div class="form-group form-group-xl">
          <label [translate]="'orderProcess.delivery.deliveryForms.recipientPhone'"></label>

          <ng-container *ngIf="countryCode">
            <ui-i18n-phone-input
              *libphonenumber
              [maxlength]="'32'"
              [defaultCountryCode]="countryCode"
              [showLabel]="false"
              [placeholder]="'common.telephone' | translate"
              [pattern]="PHONE_PATTERN"
              [formControlName]="'deliveryPhone'"
            ></ui-i18n-phone-input>
          </ng-container>
        </div>

        <div class="form-group form-group-xl">
          <label [translate]="'orderProcess.delivery.deliveryForms.messageToDriver'"></label>

          <textarea
            class="form-control"
            rows="3"
            [maxlength]="'512'"
            [placeholder]="'orderProcess.delivery.deliveryForms.messageToDriverPlaceholder'| translate"
            [formControlName]="'deliveryNote'"
          ></textarea>
        </div>

        <div class="delivery-address d-flex align-items-center mb-4 alert-circle-wrap"
             *ngIf="possibleToRegister && deliveryAddresses === null && deliveryForm.valid">
          <i class="icon-alert-circle text-orange me-2 font-3xl"></i>

          <div>
          <span class="text-muted"
                [translate]="'orderProcess.delivery.deliveryForms.signUpBenefit'">
            Save delivery details for future purchases?</span>&nbsp;
            <a href="#" (click)="$event.preventDefault(); onRegister.emit()"
               [translate]="'orderProcess.delivery.deliveryForms.signUp'"
            >Create an account</a>
          </div>
        </div>

        <div class="delivery-address d-flex align-items-center mb-4 alert-circle-wrap"
             *ngIf="deliveryAddresses !== null && deliveryForm.valid && isCurrentAddressNotSaved()">
          <ui-checkbox [(model)]="saveAddressOnSubmit">
          <span [translate]="'orderProcess.delivery.deliveryForms.saveDeliveryAddress'">
            Save delivery for next purchases
          </span>
          </ui-checkbox>
        </div>

        <div class="confirm-btn-wrap">
          <button class="btn {{nextBtnView}} delivery-confirm-btn"
                  [disabled]="isNextBtnDisabled()"
                  (click)="confirmDelivery()">
            <span [translate]="nextBtnTextKey"></span>
          </button>
        </div>
      </div>
    </form>
  </ng-container>
</div>
